<template>
  <v-card
    class="mx-auto mx-0 mt-0 mb-2 pa-0 rounded-card"
    :class="{ 'border-gradient': !product.outOfStock }"
    width="100%"
    max-width="100%"
    outlined
    light
  >
    <div class="pa-2" @click="addProductToState()">
      <v-layout align-center ma-0 row>
        <v-list three-line class="d-flex justify-start">
          <div tile color="grey">
            <div v-if="coverImageUrl" class="cover mr-2">
              <placeholder-image :url="coverImageUrl" />
            </div>
          </div>
          <div style="width: 100%">
            <div class="font-weight-bold" v-text="product.name" :class="{ 'mb-3': !product.shortDescription }" />
            <div class="text-h5 grey--text mb-1" v-text="product.shortDescription" />
            <v-chip
              label
              class="mt-2 mr-1 px-2"
              color="primary lighten-2"
              :text-color="basePriceChipTextColor"
            >
              {{ getPriceString({ amountAndCurrency: amountAndCurrency }) }}
            </v-chip>
            <v-chip v-if="showDisplayCurrency" label class="mt-2 ml-1 px-2">
              {{
                getPriceString({
                  amountAndCurrency: amountAndCurrency,
                  displayCurrency: displayCurrency,
                })
              }}
            </v-chip>
          </div>
        </v-list>
      </v-layout>
      <quantity-selector v-if="stateProduct" :productId="product.id" class="px-4" ref="quantity" />
    </div>
  </v-card>
</template>

<script>
import { mapGetters, mapState } from 'vuex'

import { textColor } from '@/lib/helpers/ColorUtils'

import reservationMixins from '@/mixins/Reservation'
import moneyMixins from '@/mixins/MoneyFormat'

export default {
  props: {
    product: { type: Object, required: true },
  },
  data () {
    return {
      basePriceChipTextColor: textColor(this.$vuetify.theme.themes.light.primary.lighten2),
    }
  },
  computed: {
    ...mapGetters('me', [
      'getPriceString',
      'showDisplayCurrency',
      'displayCurrency',
    ]),
    ...mapState({
      state: (state) => state.state,
      cartProducts: (state) => state.cart.cartProducts,
      cart: (state) => state.cart,
      account: (state) => state.activityReservations.edited.account,
      tempCartProducts: (state) => state.cart.tempCartProducts,
    }),
    amountAndCurrency () {
      const pGP = this.findPricingGroup({ pricingGroups: this.product.pricingGroupsWithPrices })
      return pGP ? pGP.prices[0][0] : null
    },
    coverImageUrl () {
      return this.product.coverImageUrl
    },
    stateProduct () {
      return this.cart.products.find(stateProduct => stateProduct.product.id === this.product.id)
    },
  },
  methods: {
    addProductToState () {
      if (this.product.outOfStock) return
      const isNew = !this.stateProduct
      this.$store.commit('cart/addProductToState', { product: this.product, isRelatedProduct: true })
      if (isNew) {
        this.$store.commit('cart/setQuantity', { quantity: 1, productId: this.product.id })
      }
    },
  },
  components: {
    QuantitySelector: () => import('@/components/view-components/catalog/QuantitySelector.vue'),
    PlaceholderImage: () => import('@/components/app-components/PlaceholderImage.vue'),
  },
  mixins: [moneyMixins, reservationMixins],
}
</script>

<style lang="scss" scoped>
.product-name {
  font-weight: bold;
  font-size: 18px;
}
.product-description {
  font-size: 16px;
}
.cover {
  min-width: 60px;
  width: 60px;
  height: 60px;
  border-radius: 8px;
  overflow: hidden;
  display: flex;
  justify-content: center;
}
.v-btn__content {
  font-size: 13px !important;
}
.rounded-card {
  border-radius: 10px !important;
}

.v-chip.bg-price {
  background: #cee4e4 !important;
}
</style>
